import React from 'react';
import { Alert, Modal } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { PENSIONS_UI_URL } from '../Api/APIURLS';


const PensionInstructionPage = ({list,show,closeModel}) => {
      const redirettoPensionPage=()=>{
          window.location.href = PENSIONS_UI_URL+"/PSAProposals"
    }
    return (
        <>
         <Modal show={show} onHide={closeModel} scrollable={true} size='xl'>
        <Modal.Header className="modal-header" closeButton>
          <Modal.Title> SR Sent Details</Modal.Title>
        
        </Modal.Header>
        <Modal.Body className="modal-body">
            <div >
                 <Alert variant="warning" className="p-3 mb-4 ">
                    <span>
                        <b>Alert Message:</b> The pension application has been approved at the PSA level and is <b>pending for more than 3 days</b> due to non-uploading of SR Sent Details and Forwarding Letter. Kindly upload the required details immediately to process the application to AG/State Audit.
                    </span>

                 </Alert>
            </div>

             <div className="inner-herbpage-service-title1 ">
                <h1>Proposal Details</h1>
              </div>
 <div className="table-responsive mt-4">
                <table className="table table-bordered table-hover table-sm align-middle">
                    <thead>
                        <tr>
                            <th className="text-center">S.No.</th>
                            <th>File Number</th>
                            <th className="text-center">Registration ID / Year</th>
                            <th>Name (Employee ID)</th>
                            <th>Designation</th>
                           
                           
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(list)&&list.map((proposal, index) => (
                            <tr key={`${index}`}>
                                <td className="text-center">{index + 1}</td>
                                <td>{(proposal.fileNumber)}</td>
                                <td className="text-center">{proposal.registrationId}</td>
                                <td>{proposal.employeeName }{`(${proposal.cfmsId})`}</td>
                                <td>{proposal.designation||'-'}</td>
                              
                               
                               
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


             <div>
                 <Alert variant="info" className="p-3 mt-4 ">
                    <span>
                        <b>Note:</b> To upload SR Sent Details:<br/>

                                   <b>Checker-1:</b> Go to Pension Proposal Process Checker-1 → Forward List.<br/>

<                                   b>PSA:</b> Go to Pension Proposal → Pension Application - PSA → Pending List and click <b>"Upload SR Sent Details".</b>
                    </span>

                 </Alert>
            </div>


        </Modal.Body>
        <Modal.Footer>
             {/* <button type="button" className="btn btn-success"  
            onClick={redirettoPensionPage}>Proceed</button> */}
              <button type="button" className="btn btn-primary"  
            onClick={closeModel}>Close</button>
        </Modal.Footer>
        </Modal>
            
        </>
    );
};

export default PensionInstructionPage;